import React from 'react';
import { Helmet } from 'react-helmet';
import AboutMe from '../../Components/AboutMe/AboutMe';
import Blog from '../../Components/Blog/Blog';
import Contact from '../../Components/Contact/Contact';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import Hero from '../../Components/Hero/Hero';
import Work from '../../Components/Work/Work';
import './home.scss'
const Home = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>NokibRokes | Full-stack web developer</title>
                <link rel="canonical" href="https://nokibrokes.com/" />
            </Helmet>
            <Header></Header>
            <Hero></Hero>
            <AboutMe/>
            <Work isHome={true}></Work>
            <Blog isHome={true}></Blog>
            <Contact></Contact>
            <Footer></Footer>
        </>
    );
};

export default Home;